import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import { ValidationService } from '../../core/services/validation/validation.service';
import { HttpService } from '../../core/services/http/http.service';
import { Store } from '@ngrx/store';
import { Register } from '../../../store/actions/authenticationActions';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {

  constructor(private http: HttpService, private store: Store<any>) { }
  static formFields() {
    return {
      'email': [null, Validators.compose([Validators.required, ValidationService.emailValidator])],
      'password': [null, Validators.compose([Validators.required, ValidationService.passwordValidator])],
      'first_name' : [null , Validators.required],
      'last_name' : [null , Validators.required]
    }
  }

  

  signUp(data) {
    // return this.store.select('authenticationReducer');
    return this.http.query('post', 'user/register', {}, '', data);
  }

}
